export default __webpack_public_path__ + "SolutionImage4.fe625d7.png";